import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
// import AuthSliceReducer from "./AuthSlice";
import CommonSliceReducer from "./CommonSlice";

const store = configureStore({
  reducer: {
    // AUTH: AuthSliceReducer,

    COMMON: CommonSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<any>
>;

export default store; // Export the store as the default export
